import React, { useMemo } from 'react';
import { ordersCreatedTodaySpecification } from '../../../utilities/pcDashboard/orderSpecifications';
import { useSearchOrdersQuery } from '../../../API/order/OrderApi';
import { ErrorMessageTW } from '../../../tailwindComponents/errorMessage/ErrorMessageTW';
import { LoadingSpinnerTW } from '../../../tailwindComponents/loadingSpinnerTW/LoadingSpinnerTW';
import { MetricCard } from './MetricCard';
import { clientUrls } from '../../../ui-toolkit/rest/ClientUrlFactory';
import { FolderOpenIcon } from '@heroicons/react/24/outline';

export const OrdersCreatedToday: React.FC = () => {
  const ordersCreatedToday = useMemo(() => ordersCreatedTodaySpecification(), []);
  const {
    data: openedTodayData,
    isFetching: openedTodayIsFetching,
    error: openedTodayError,
  } = useSearchOrdersQuery(ordersCreatedToday);
  if (openedTodayError) {
    return (
      <div className={'flex-1'}>
        <ErrorMessageTW rtkError={openedTodayError} />
      </div>
    );
  }
  return (
    <LoadingSpinnerTW isLoading={openedTodayIsFetching}>
      <MetricCard
        href={clientUrls.urlFor.adminOrders(ordersCreatedToday)}
        title={'Orders Created Today'}
        data={openedTodayData?.totalElements ?? 0}
        icon={<FolderOpenIcon className={'text-white'} />}
        iconClassName={'bg-blue-500'}
      />
    </LoadingSpinnerTW>
  );
};
